import { generator } from '../event-listener.js';
export const OnBeforeClose = generator('onBeforeClose');
export const OnClose = generator('onClose');
//# sourceMappingURL=closeable.js.map